var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { generateReducer, } from "../generators/generator.reducer";
import { removeBankAccountStart, removeBankAccountSucceeded, removeBankAccountFailed, updateBankAccountOwnerNameStart, updateBankAccountOwnerNameSucceeded, updateBankAccountOwnerNameFailed, getContactBankAccountsStart, getContactBankAccountsSucceeded, getContactBankAccountsFailed, createContactBankAccountStart, createContactBankAccountSucceeded, createContactBankAccountFailed, } from "./bankAccount.actions";
import { GENERATOR_PARAMS } from "./bankAccount.constants";
import { getContactBankAccountsKey } from "./bankAccount.utils";
var getExtraDefaultState = function () { return ({
    removeBankAccount: {},
    updateBankAccountOwnerName: {},
    contactBankAccounts: {},
    createContactBankAccount: { pending: false },
}); };
var _reducer = generateReducer(GENERATOR_PARAMS, getExtraDefaultState);
var reducer = _reducer;
reducer.on(removeBankAccountStart.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { removeBankAccount: __assign(__assign({}, state.removeBankAccount), (_a = {}, _a[payload.id] = __assign(__assign({}, state.removeBankAccount[payload.id]), { pending: true, error: undefined }), _a)) });
});
reducer.on(removeBankAccountSucceeded.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { removeBankAccount: __assign(__assign({}, state.removeBankAccount), (_a = {}, _a[payload.id] = __assign(__assign({}, state.removeBankAccount[payload.id]), { pending: false, result: payload.result, error: undefined }), _a)) });
});
reducer.on(removeBankAccountFailed.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { removeBankAccount: __assign(__assign({}, state.removeBankAccount), (_a = {}, _a[payload.id] = __assign(__assign({}, state.removeBankAccount[payload.id]), { pending: false, error: payload.error }), _a)) });
});
reducer.on(updateBankAccountOwnerNameStart.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { updateBankAccountOwnerName: __assign(__assign({}, state.updateBankAccountOwnerName), (_a = {}, _a[payload.id] = __assign(__assign({}, state.updateBankAccountOwnerName[payload.id]), { pending: true, error: undefined }), _a)) });
});
reducer.on(updateBankAccountOwnerNameSucceeded.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { updateBankAccountOwnerName: __assign(__assign({}, state.updateBankAccountOwnerName), (_a = {}, _a[payload.id] = __assign(__assign({}, state.updateBankAccountOwnerName[payload.id]), { pending: false, result: payload.result, error: undefined }), _a)) });
});
reducer.on(updateBankAccountOwnerNameFailed.type, function (state, payload) {
    var _a;
    return __assign(__assign({}, state), { updateBankAccountOwnerName: __assign(__assign({}, state.updateBankAccountOwnerName), (_a = {}, _a[payload.id] = __assign(__assign({}, state.updateBankAccountOwnerName[payload.id]), { pending: false, error: payload.error }), _a)) });
});
reducer.on(getContactBankAccountsStart.type, function (state, payload) {
    var _a;
    var key = getContactBankAccountsKey(payload);
    if (!key) {
        return state;
    }
    return __assign(__assign({}, state), { contactBankAccounts: __assign(__assign({}, state.contactBankAccounts), (_a = {}, _a[key] = __assign(__assign({}, state.contactBankAccounts[key]), { pending: true, error: undefined }), _a)) });
});
reducer.on(getContactBankAccountsSucceeded.type, function (state, payload) {
    var _a;
    var key = getContactBankAccountsKey(payload);
    if (!key) {
        return state;
    }
    return __assign(__assign({}, state), { contactBankAccounts: __assign(__assign({}, state.contactBankAccounts), (_a = {}, _a[key] = __assign(__assign({}, state.contactBankAccounts[key]), { pending: false, items: payload.result, error: undefined }), _a)) });
});
reducer.on(getContactBankAccountsFailed.type, function (state, payload) {
    var _a;
    var key = getContactBankAccountsKey(payload);
    if (!key) {
        return state;
    }
    return __assign(__assign({}, state), { contactBankAccounts: __assign(__assign({}, state.contactBankAccounts), (_a = {}, _a[key] = __assign(__assign({}, state.contactBankAccounts[key]), { pending: false, error: payload.error }), _a)) });
});
reducer.on(createContactBankAccountStart.type, function (state) { return (__assign(__assign({}, state), { createContactBankAccount: { pending: true, error: undefined } })); });
reducer.on(createContactBankAccountSucceeded.type, function (state, payload) {
    var _a;
    var key = getContactBankAccountsKey(payload);
    var nextState = __assign(__assign({}, state), { createContactBankAccount: { pending: false, error: undefined } });
    if (!key) {
        return nextState;
    }
    var cached = state.contactBankAccounts[key];
    return __assign(__assign({}, nextState), { contactBankAccounts: __assign(__assign({}, state.contactBankAccounts), (_a = {}, _a[key] = __assign(__assign({}, cached), { items: __spreadArray([payload.result], ((cached === null || cached === void 0 ? void 0 : cached.items) || []), true) }), _a)) });
});
reducer.on(createContactBankAccountFailed.type, function (state, payload) { return (__assign(__assign({}, state), { createContactBankAccount: { pending: false, error: payload.error } })); });
// eslint-disable-next-line import/no-default-export
export default reducer;
